// import axios from 'axios';
let API_URL = '';
export let WAPI_URL = '';
let headers = {};

export function setApiUrlFromIntegration(integration) {
  API_URL = integration.api_url || ' ';
  WAPI_URL = integration.wapi_url || ' ';
  headers = {
    headers: { 'x-access-token': integration.access_token },
  };
}

export function hasUsableWiseApiUrl(url = API_URL) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch (error) {
    return false;
  }
}

export async function getUser() {
  if (!hasUsableWiseApiUrl()) {
    return null;
  }

  try {
    const response = await axios.get(`${API_URL}/user`, headers);

    return response.data.res;
  } catch (error) {
    console.error('Erro ao buscar os dados do Dashboard:', error);
    return null;
  }
}

export async function getConnectionWapi({ secret, id }) {
  try {
    const response = await axios.get(
      `${WAPI_URL}/api/session/fetch/${secret}/${id}`
    );

    return response.data;
  } catch (error) {
    console.error('Erro ao buscar os dados de Conexão:', error);
    return {
      clientConnected: false,
    };
  }
}

export async function getQueue({ id }) {
  try {
    const { data } = await axios.get(`${API_URL}/queue/${id}`, headers);
    const list = data.map(customer => customer.client_id);
    const customersInQueue = await axios.post(
      `${API_URL}/customer/customers_in_queue
`,
      { list, user_id: id },
      headers
    );
    return customersInQueue;
  } catch (error) {
    console.error('Erro ao buscar os dados do Dashboard:', error);
    return null;
  }
}

export async function getTags() {
  try {
    const data = await axios.get(`${API_URL}/tag`, headers);

    return data;
  } catch (error) {
    console.error('Erro ao buscar tags:', error);
    return null;
  }
}

export async function getExpressStatus() {
  try {
    const response = await axios.get(`${API_URL}/express-status`, headers);

    return response;
  } catch (error) {
    console.error('Erro ao buscar os Status de Veículo:', error);
    return null;
  }
}

export async function getExpressRegional() {
  try {
    const response = await axios.get(`${API_URL}/express-regional`, headers);
    return response;
  } catch (error) {
    console.error('Erro ao buscar Regional:', error);
    return null;
  }
}

export async function getExpressAssociateSituation() {
  try {
    const response = await axios.get(`${API_URL}/associate`, headers);
    return response;
  } catch (error) {
    console.error('Erro ao buscar Sitauções de boleto:', error);
    return null;
  }
}

export async function getExpressBilletSituation() {
  try {
    const response = await axios.get(`${API_URL}/billet-situation`, headers);
    return response;
  } catch (error) {
    console.error('Erro ao buscar Sitauções de boleto:', error);
    return null;
  }
}

export async function getUserMessage({ id }) {
  try {
    const response = await axios.get(`${API_URL}/message/${id}`, headers);

    return response;
  } catch (error) {
    console.error('Erro ao buscar Mensagens do usuário:', error);
    return null;
  }
}

export async function sendDirectExpressShippint({ hub_url, payload }) {
  try {
    const response = await axios.post(hub_url, payload, {});

    return response;
  } catch (error) {
    console.error('Erro ao iniciar processo de integração:', error);
    throw error.response;
  }
}

export async function changeStatusQueue({ payload }) {
  try {
    const response = await axios.post(
      `${API_URL}/user/statusQueue`,
      payload,
      headers
    );

    return response;
  } catch (error) {
    console.error('Erro ao iniciar alterar status da fila:', error);
    throw error.response;
  }
}

export async function clearQueue({ payload }) {
  try {
    const response = await axios.post(
      `${API_URL}/queue/clear`,
      payload,
      headers
    );

    return response;
  } catch (error) {
    console.error('Erro ao iniciar alterar status da fila:', error);
    throw error.response;
  }
}

export async function getCategories() {
  try {
    const data = await axios.get(`${API_URL}/category`, headers);

    return data;
  } catch (error) {
    console.error('Erro ao buscar categorias:', error);
    return null;
  }
}

export async function createMessageInWise({ payload }) {
  try {
    const data = await axios.post(`${API_URL}/message/file`, payload, headers);

    return data;
  } catch (error) {
    console.error('Erro ao buscar categorias:', error);
    return null;
  }
}

export async function updateMessageInWise({ payload, message_id }) {
  try {
    const data = await axios.put(
      `${API_URL}/message/file/${message_id}`,
      payload,
      headers
    );

    return data;
  } catch (error) {
    console.error('Erro ao atualizar mensagem:', error);
    return null;
  }
}

export async function createWapiConnectionWise({ secret }) {
  try {
    const data = await axios.get(`${WAPI_URL}/api/session/start/${secret}`);

    return data;
  } catch (error) {
    console.error('Erro ao buscar categorias:', error);
    return null;
  }
}

export async function updateUser({ user }) {
  try {
    const data = await axios.put(`${API_URL}/user/${user._id}`, user, headers);

    return data;
  } catch (error) {
    console.error('Erro ao atualizar usuário:', error);
    return error;
  }
}

export async function deleteMessageWise({ message }) {
  try {
    const data = await axios.delete(
      `${API_URL}/message/${message._id}`,
      headers
    );

    return data;
  } catch (error) {
    console.error('Erro ao atualizar usuário:', error);
    return error;
  }
}

export async function closeWapiConnectionWise({ user }) {
  try {
    const data = await axios.get(
      `${WAPI_URL}/api/session/stop/${user.secret}/${user.device_id}`
    );
    console.log('Conexão encerrada', data);
    return;
  } catch (error) {
    console.error('Erro ao atualizar usuário:', error);
    return error;
  }
}

export async function sendWapiTestMessageWise({ message }) {
  try {
    const data = await axios.post(`${WAPI_URL}/api/session/message`, message);
    return {
      message: 'Mensagem enviada',
      data,
    };
  } catch (error) {
    console.error('Erro ao enviar mensagem de test:', error);
    return error;
  }
}

export function getContactWiseConversations(accountId, contactId) {
  return axios.get(
    `/api/v1/accounts/${accountId}/wise/contact/${contactId}/conversations`
  );
}
